module.exports = __webpack_public_path__ + "img/category-tickets.70cbd232.jpg";